import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var CaretUp = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("path", { d: 'M3.75 12.5L10 6.25L16.25 12.5', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }))); };

export { CaretUp as default };
//# sourceMappingURL=CaretUp.js.map
